
import React, { useCallback, useRef, useState } from 'react';

import { Box } from '@mui/material';
import { useCurrentuser } from '@uplift/contexts';
import { trackLeaveSessionClick, useIsMobile } from '@uplift/hooks';
import { useLocalAudioToggle, useLocalScreenShareToggle, useLocalVideoToggle } from '../../../hooks';
import { Button } from '@uplift/ui-v2';

import { AudioControlButtonn } from './AudioControlButton.component';
import { ScreenShareControlButton } from './ScreenShareControlButton.component';
import { SettingsControlButton } from './SettingsControlButton.component';
import { SettingsModal } from './SettingsModal.component';
import { useVideoStyles } from './styles';
import { VideoControlButtonn } from './VideoControlButton.component';

export type MainVideoControlPanelProps = {
  hungUpHandler: () => void;
  sessionDetails?: string;
  isBlurAvaibile?: boolean;
};

export const MainVideoControlPanel: React.FC<MainVideoControlPanelProps> = ({ hungUpHandler, isBlurAvaibile }) => {
  const isMobile = useIsMobile();
  const { classes } = useVideoStyles({});
  const me = useCurrentuser();
  const [ settingsModalOpen, setSettingsModalOpen ] = useState(false);
  const [ isAudioEnabled, toggleAudioEnabled ] = useLocalAudioToggle();
  const [ isVideoEnabled, toggleVideoEnabled ] = useLocalVideoToggle();
  const { isScreenShareEnabled, toggleScreenShare, disableScreenShareToggle } = useLocalScreenShareToggle();
  const lastClickTimeRef = useRef(0);

  const toggleVideo = useCallback(() => {
    if (Date.now() - lastClickTimeRef.current > 500) {
      lastClickTimeRef.current = Date.now();
      toggleVideoEnabled();
    }
  }, [ toggleVideoEnabled ]);

  const leaveSessionHandler = () => {
    trackLeaveSessionClick({
      userType: me?.role
    });
    hungUpHandler();
  };

  return (
    <Box display="flex" alignItems="center" justifyContent="center" gap="1.5rem">
      <SettingsModal
        open={settingsModalOpen}
        onClose={() => setSettingsModalOpen(false)}
        isBlurAvailable={isBlurAvaibile}
      />
      <SettingsControlButton
        onToggleActive={() => setSettingsModalOpen(true)}
      />
      <AudioControlButtonn
        isActive={isAudioEnabled}
        onToggleActive={toggleAudioEnabled}
      />
      <VideoControlButtonn
        isActive={isVideoEnabled}
        onToggleActive={toggleVideo}
      />
      {!isMobile && (
        <ScreenShareControlButton
          isActive={isScreenShareEnabled}
          onToggleActive={toggleScreenShare}
          disableToggle={disableScreenShareToggle}
        />
      )}
      <Button
        variant="contained"
        color="error"
        className={classes.leaveSessionButton}
        onClick={leaveSessionHandler}
      >
        Leave
      </Button>
    </Box>
  );
};
